// extracted by mini-css-extract-plugin
export default {"SidebarCard":"sidebarCard-module_SidebarCard_NamnS"};